import { render, staticRenderFns } from "./BiomassMetaData.vue?vue&type=template&id=906f3c96&lang=html&"
import script from "./BiomassMetaData.vue?vue&type=script&lang=js&"
export * from "./BiomassMetaData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports